import React, { useEffect, useState } from "react"

import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../../../store/store"
import API from "../../../../api"
import BottomGradient from "../../../../components/bottomGradient"
import Button from "../../../../components/button"
import GUIDELINE_RULES from "../../../../constants/guidelineRules"

import { useLanguage } from "@languages/index"

const USER_TYPE = {
  RENTAL_NORMAL: 21,
} as const

const RequirementsBasic = (props: any) => {
  const [images, setImages] = useState<any>([])

  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.rental }

  const fetchImages = () => {
    API.GuidelineRules.create({
      userTypeFl: USER_TYPE.RENTAL_NORMAL,
      outputType: GUIDELINE_RULES.OUTPUT_TYPES.PHOTO,
    })
      .then((response) => {
        const result = Object.values(response.data.rules)
        setImages(result)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const setHasAgreedGuidelineTerms = () => {
    API.Brand.update({
      ...{
        brandToken: props.auth.token,
        hasAgreedGuidelineTerms: 1,
      },
    })
      .then((response) => {
        props.setBrand({ hasAgreedGuidelineTerms: 1 })
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  useEffect(() => {
    fetchImages()
  }, [])

  return (
    <div
      className="w-full flex flex-col items-center justify-center px-5 pb-10"
      style={{ paddingTop: props.preferences.headerHeight }}
    >
      <div className="flex flex-col w-full gap-[50px] mx-auto max-w-[1024px]">
        <div className="flex flex-col text-[36px] font-bold">{languageTexts.ambassador_index_text_54}</div>
        <div className="flex flex-col gap-5">
          <div className="text-[22px] font-bold">{languageTexts.ambassador_index_text_59}</div>
          <ul className="flex flex-col gap-[5px] text-[15px] text-[#FF0000] ">
            <li>{languageTexts.ambassador_index_text_60}</li>
            <li>{languageTexts.ambassador_index_text_61}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-5">
          <div className="text-[22px] font-bold">{languageTexts.ambassador_index_text_62}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 pb-6 gap-2">
            {images.map(({ id, order, groupName, value }) => {
              if (value != null && value.indexOf("/guide/tag-guide") >= 0) {
                return <img key={id} src={value} id={id} />
              }
            })}
          </div>
        </div>

        <div className="flex flex-col gap-5">
          <div className="text-[22px] font-bold">{languageTexts.ambassador_index_text_63}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 pb-6 gap-2">
            {images.map(({ id, order, groupName, value }) => {
              if (value != null && value.indexOf("/guide/posting-guide") >= 0) {
                return <img key={id} src={value} id={id} />
              }
            })}
          </div>
        </div>
      </div>
      {!props.brand.hasAgreedGuidelineTerms && (
        <div className="flex flex-col fixed w-full left-0 right-0 bottom-0 justify-between">
          <div className="hidden md:flex">
            <BottomGradient />
          </div>
          <div className="fixed md:w-[240px] bottom-0 right-0 left-0 mx-auto md:left-auto md:right-5 form-submit-button md:rounded-sm md:mb-6 z-[2]">
            <Button
              className={"px-3 py-[22.5px] md:py-3 text-center"}
              textColor={"WHITE"}
              buttonColor={"BLACK"}
              borderColor={"BLACK"}
              text={languageTexts.ambassador_index_text_64}
              onClick={() => {
                props.showModal({
                  title: languageTexts.ambassador_index_text_65,
                  text: languageTexts.ambassador_index_text_66,
                  cancel: () => {},
                  confirmButtonText: languageTexts.ambassador_index_text_67,
                  confirm: () => setHasAgreedGuidelineTerms(),
                })
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(RequirementsBasic)
